import assest from "../../../json/assest";
// import Image from "next/image";
import React, { ChangeEvent, ReactEventHandler, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import EmptyTable from "../../../components/EmptyTable/EmptyTable";
import NoResult from "../../../components/NoResult/NoResult";
import styles from "../../../styles/components/MemberPageTable/MemberPageTable.module.scss";
import styles1 from "../../../styles/components/partnerSubmissionFeeModal.module.scss";
import styles2 from "../../../styles/pages/home.module.scss";
import MemberApproveTable from "./MemberApproveTable";
import MemberDuplicateTable from "./MemberDuplicateTable";
import MemberPendingVideoTable from "./MemberPendingVideoTable";
import MemberRejectedTable from "./MemberRejectedTable";
import MemberWebsiteTable from "./MemberWebsiteTable";
import Filter from "../../../components/Filter/Filter";
import PerfectScrollbar from "react-perfect-scrollbar";
// import useFetch from "../../../api/useFetch";
import useFetch, { usePost } from "../../../hooks/api/useFetch";
import ApiLoader from "../../Loaders/ApiLoader";

const getVideosFilterBody = (filters) => {
  var filterBody = { user_id: filters?.user_id };
  if (filters?.searchString) filterBody.search = filters?.searchString;
  if (filters?.paginationCurrentPage)
    filterBody.page = filters?.paginationCurrentPage;
  if (filters?.filterLocation) filterBody.country = filters?.filterLocation;
  if (filters?.has_note) filterBody.has_note = filters?.has_note;
  if (filters?.show_potential_duplicates)
    filterBody.show_potential_duplicates = filters?.show_potential_duplicates;
  if (filters?.unreachable_submitter)
    filterBody.unreachable_submitter = filters?.unreachable_submitter;
  if (filters?.has_pending_message)
    filterBody.has_pending_message = filters?.has_pending_message;
  if (filters?.people_appearing)
    filterBody.people_appearing = filters?.people_appearing;
  if (filters?.person_who_filmed)
    filterBody.person_who_filmed = filters?.person_who_filmed;
  if (filters?.submit_other_website)
    filterBody.submit_other_website = filters?.submit_other_website;
  if (filters?.aggrement_with_another_company)
    filterBody.aggrement_with_another_company =
      filters?.aggrement_with_another_company;
  if (filters?.filterMonth?.length && filters?.filterYear?.length) {
    filterBody.from = `${year}-${month}-01`;
    filterBody.to = `${year}-${month}-31`;
  } else if (
    filters?.submissionsDate?.startDate &&
    filters?.submissionsDate?.endDate
  ) {
    filterBody.from = `${filters?.submissionsDate?.startDate}`;
    filterBody.to = `${filters?.submissionsDate?.endDate}`;
  }
  if (filters?.videoStatusFilter.toString()) {
    if (filters?.videoStatusFilter === 3) {
      filterBody.duplicate = "yes";
    } else {
      filterBody.status = filters?.videoStatusFilter.toString();
    }
  }
  if (filters?.awaitingConfirmation) {
    filterBody.awaitingConfirmation = "yes";
    if (filters?.videoStatusFilter === 1) {
      filterBody.type = "approved";
      filterBody.status = null;
    } else if (filters?.videoStatusFilter === 2) {
      filterBody.type = "rejected";
      filterBody.status = null;
    } else if (filters?.videoStatusFilter === 5) {
      filterBody.type = "website";
      filterBody.status = null;
    }
  }
  console.warn(filterBody);
  return filterBody;
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MemberPageTable(props) {
  const [value, setValue] = React.useState(0);
  const [videoStatusFilter, setVideoStatusFilter] = React.useState(value);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 2) {
      setVideoStatusFilter(5);
    } else if (newValue === 4) {
      setVideoStatusFilter(2);
    } else {
      setVideoStatusFilter(newValue);
    }
  };

  const [searchString, setSearchString] = useState("");

  const handleSearchStringChange = (event) => {
    setSearchString(event.target.value);
  };

  const [filterParams, setFilterParams] = useState(null);

  const resetFilterparams = () => {
    setFilterParams(null);
    setFilterMonth("");
    setFilterYear("");
    setFilterLocation("");
  };

  const [filterMonth, setFilterMonth] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [filterLocation, setFilterLocation] = useState("");

  const [submissionsDate, setSubmissionsDate] = useState({
    startDate: 0,
    endDate: 0,
  });
  const handleDateChange = (val) => {
    setSubmissionsDate(val);
  };

  const [page, setPage] = React.useState(1);
  const handlePageChange = (e) => {
    setPage(e);
  };
  const [awaitingConfirmation, setAwaitingConfirmation] = useState(false);

  const handleAwaitingConfirmation = () => {
    setAwaitingConfirmation((prev) => !prev);
  };
  const {
    data: videos,
    isError: videosIsError,
    isLoading: videosIsLoading,
    isSuccess: videosIsSuccess,
  } = usePost(
    [
      "member-videos",
      props?.user_id,
      filterParams,
      filterLocation,
      filterMonth,
      filterYear,
      searchString,
      submissionsDate,
      videoStatusFilter,
      page,
      awaitingConfirmation,
    ],
    `/admin/videos?user_id=${props?.user_id}`,
    getVideosFilterBody({
      user_id: props?.user_id,
      ...filterParams,
      filterLocation,
      filterMonth,
      filterYear,
      searchString,
      submissionsDate,
      videoStatusFilter,
      page,
      awaitingConfirmation,
    })
  );

  return (
    <Box className={`${styles1.submitTableMain} ${styles.bodyScroll}`}>
      <ApiLoader
        loading={
          videosIsLoading &&
          !(
            videosIsSuccess ||
            videos?.data?.data?.length ||
            searchString.length ||
            filterParams !== null ||
            submissionsDate.startDate ||
            submissionsDate.endDate ||
            awaitingConfirmation
          )
        }
      />

      {/* <PerfectScrollbar> */}
      <Box className={styles.bttmGap}>
        <Box className={styles1.submitHeader}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            className={styles.partnerTableHeader}
          >
            <Tab
              label={
                <>
                  <Box className="tabBox partnertabBox">
                    <Box className="tabIcon">
                      <img
                        src={assest.pendingIcon}
                        width={22}
                        height={22}
                        alt=""
                      />
                    </Box>
                    <p>
                      Pending Videos <br />{" "}
                      {props?.videoCount?.pending
                        ? props?.videoCount?.pending
                        : "-"}
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(0)}
            />
            <Tab
              label={
                <>
                  <Box className="tabBox partnertabBox">
                    <Box className="tabIcon">
                      <img
                        src={assest.allPlatfromIcon}
                        width={22}
                        height={22}
                        alt=""
                      />
                    </Box>
                    <p>
                      Approved Videos <br />{" "}
                      {props?.videoCount?.approved
                        ? props?.videoCount?.approved
                        : "-"}
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(1)}
            />
            <Tab
              label={
                <>
                  <Box className="tabBox partnertabBox">
                    <Box className="tabIcon">
                      <img
                        src={assest.globalIcon}
                        width={22}
                        height={22}
                        alt=""
                      />
                    </Box>
                    <p>
                      Website Only <br />{" "}
                      {props?.videoCount?.website_only
                        ? props?.videoCount?.website_only
                        : "-"}
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(2)}
            />
            <Tab
              label={
                <>
                  <Box className="tabBox partnertabBox">
                    <Box className="tabIcon">
                      <img
                        src={assest.duplicateIcon}
                        width={22}
                        height={22}
                        alt=""
                      />
                    </Box>
                    <p>
                      Duplicated Videos <br />{" "}
                      {props?.videoCount?.duplicate_videos
                        ? props?.videoCount?.duplicate_videos
                        : "-"}
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(3)}
            />
            <Tab
              label={
                <>
                  <Box className="tabBox partnertabBox">
                    <Box className="tabIcon">
                      <img
                        src={assest.crossRoundIcon}
                        width={22}
                        height={22}
                        alt=""
                      />
                    </Box>
                    <p>
                      Rejected Videos <br />{" "}
                      {props?.videoCount?.rejected
                        ? props?.videoCount?.rejected
                        : "-"}
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(4)}
            />
          </Tabs>
        </Box>

        <Box className={`${styles1.submitTablePartner} ${styles2.submitTable}`}>
          <TabPanel value={value} index={0}>
            {videosIsLoading &&
            !(
              videosIsSuccess ||
              videos?.data?.data?.length ||
              searchString.length ||
              filterParams !== null ||
              filterMonth ||
              filterYear ||
              filterLocation ||
              submissionsDate.startDate ||
              submissionsDate.endDate ||
              awaitingConfirmation
            ) ? (
              ""
            ) : videosIsSuccess ||
              filterMonth ||
              filterYear ||
              filterLocation ||
              submissionsDate.startDate ||
              submissionsDate.endDate ||
              awaitingConfirmation ? (
              <MemberPendingVideoTable
                searchString={searchString}
                videos={videos?.data}
                handleFilter={setFilterParams}
                setFilterMonth={setFilterMonth}
                setFilterYear={setFilterYear}
                setFilterLocation={setFilterLocation}
                modalMonthFilter={filterMonth}
                modalYearFilter={filterYear}
                modalLocationFilter={filterLocation}
                handleSearchStringChange={handleSearchStringChange}
                resetFilterparams={resetFilterparams}
                modalFields={filterParams}
                handleDateChange={handleDateChange}
                handlePageChange={handlePageChange}
                submissionsDate={submissionsDate}
              />
            ) : filterParams !== null ? (
              <Filter resetFilters={resetFilterparams} />
            ) : (
              <EmptyTable
                emptyTableText={"All is clear! No pending videos found. Please refresh the page or check again later.".split(
                  "."
                )}
              />
            )}
          </TabPanel>

          <TabPanel value={value} index={1}>
            {videosIsLoading &&
            !(
              videosIsSuccess ||
              videos?.data?.data?.length ||
              searchString.length ||
              filterParams !== null ||
              filterMonth ||
              filterYear ||
              filterLocation ||
              submissionsDate.startDate ||
              submissionsDate.endDate ||
              awaitingConfirmation
            ) ? (
              ""
            ) : videosIsSuccess ||
              filterMonth ||
              filterYear ||
              filterLocation ||
              submissionsDate.startDate ||
              submissionsDate.endDate ||
              awaitingConfirmation ? (
              <MemberApproveTable
                searchString={searchString}
                videos={videos?.data}
                handleFilter={setFilterParams}
                setFilterMonth={setFilterMonth}
                setFilterYear={setFilterYear}
                setFilterLocation={setFilterLocation}
                modalMonthFilter={filterMonth}
                modalYearFilter={filterYear}
                modalLocationFilter={filterLocation}
                handleSearchStringChange={handleSearchStringChange}
                resetFilterparams={resetFilterparams}
                modalFields={filterParams}
                handleDateChange={handleDateChange}
                handlePageChange={handlePageChange}
                submissionsDate={submissionsDate}
                handleAwaitingConfirmation={handleAwaitingConfirmation}
              />
            ) : filterParams !== null ? (
              <Filter resetFilters={resetFilterparams} />
            ) : (
              <EmptyTable
                emptyTableText={"All is clear! No pending videos found. Please refresh the page or check again later.".split(
                  "."
                )}
              />
            )}
          </TabPanel>

          <TabPanel value={value} index={2}>
            {videosIsLoading &&
            !(
              videosIsSuccess ||
              videos?.data?.data?.length ||
              searchString.length ||
              filterParams !== null ||
              filterMonth ||
              filterYear ||
              filterLocation ||
              submissionsDate.startDate ||
              submissionsDate.endDate ||
              awaitingConfirmation
            ) ? (
              ""
            ) : videosIsSuccess ||
              filterMonth ||
              filterYear ||
              filterLocation ||
              submissionsDate.startDate ||
              submissionsDate.endDate ||
              awaitingConfirmation ? (
              <MemberWebsiteTable
                searchString={searchString}
                videos={videos?.data}
                handleFilter={setFilterParams}
                setFilterMonth={setFilterMonth}
                setFilterYear={setFilterYear}
                setFilterLocation={setFilterLocation}
                modalMonthFilter={filterMonth}
                modalYearFilter={filterYear}
                modalLocationFilter={filterLocation}
                handleSearchStringChange={handleSearchStringChange}
                resetFilterparams={resetFilterparams}
                modalFields={filterParams}
                handleDateChange={handleDateChange}
                handlePageChange={handlePageChange}
                submissionsDate={submissionsDate}
                handleAwaitingConfirmation={handleAwaitingConfirmation}
              />
            ) : filterParams !== null ? (
              <Filter resetFilters={resetFilterparams} />
            ) : (
              <EmptyTable
                emptyTableText={"All is clear! No pending videos found. Please refresh the page or check again later.".split(
                  "."
                )}
              />
            )}
          </TabPanel>

          <TabPanel value={value} index={3}>
            {videosIsLoading &&
            !(
              videosIsSuccess ||
              videos?.data?.data?.length ||
              searchString.length ||
              filterParams !== null ||
              filterMonth ||
              filterYear ||
              filterLocation ||
              submissionsDate.startDate ||
              submissionsDate.endDate ||
              awaitingConfirmation
            ) ? (
              ""
            ) : videosIsSuccess ||
              filterMonth ||
              filterYear ||
              filterLocation ||
              submissionsDate.startDate ||
              submissionsDate.endDate ||
              awaitingConfirmation ? (
              <MemberDuplicateTable
                searchString={searchString}
                videos={videos?.data}
                handleFilter={setFilterParams}
                handleSearchStringChange={handleSearchStringChange}
                resetFilterparams={resetFilterparams}
                modalFields={filterParams}
                handleDateChange={handleDateChange}
                handlePageChange={handlePageChange}
                submissionsDate={submissionsDate}
              />
            ) : filterParams !== null ? (
              <Filter resetFilters={resetFilterparams} />
            ) : (
              <EmptyTable
                emptyTableText={"All is clear! No pending videos found. Please refresh the page or check again later.".split(
                  "."
                )}
              />
            )}
          </TabPanel>

          <TabPanel value={value} index={4}>
            {videosIsLoading &&
            !(
              videosIsSuccess ||
              videos?.data?.data?.length ||
              searchString.length ||
              filterParams !== null ||
              filterMonth ||
              filterYear ||
              filterLocation ||
              submissionsDate.startDate ||
              submissionsDate.endDate ||
              awaitingConfirmation
            ) ? (
              ""
            ) : videosIsSuccess ||
              filterMonth ||
              filterYear ||
              filterLocation ||
              submissionsDate.startDate ||
              submissionsDate.endDate ||
              awaitingConfirmation ? (
              <MemberRejectedTable
                searchString={searchString}
                videos={videos?.data}
                handleFilter={setFilterParams}
                setFilterMonth={setFilterMonth}
                setFilterYear={setFilterYear}
                setFilterLocation={setFilterLocation}
                modalMonthFilter={filterMonth}
                modalYearFilter={filterYear}
                modalLocationFilter={filterLocation}
                handleSearchStringChange={handleSearchStringChange}
                resetFilterparams={resetFilterparams}
                modalFields={filterParams}
                handleDateChange={handleDateChange}
                handlePageChange={handlePageChange}
                submissionsDate={submissionsDate}
                handleAwaitingConfirmation={handleAwaitingConfirmation}
              />
            ) : filterParams !== null ? (
              <Filter resetFilters={resetFilterparams} />
            ) : (
              <EmptyTable
                emptyTableText={"All is clear! No pending videos found. Please refresh the page or check again later.".split(
                  "."
                )}
              />
            )}
          </TabPanel>
        </Box>
      </Box>
      {/* </PerfectScrollbar> */}
    </Box>
  );
}
